import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

import JsonCode from "./JsonCode";

// Axle AI answers in Markdown, mostly tables and json code blocks, styled to
// match the dashboard's tables.
const components: Components = {
  p: ({ children }) => <p className="leading-6">{children}</p>,
  ul: ({ children }) => (
    <ul className="list-disc pl-5 space-y-1">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="list-decimal pl-5 space-y-1">{children}</ol>
  ),
  a: ({ children, href }) => (
    <a href={href} target="_blank" rel="noreferrer" className="underline">
      {children}
    </a>
  ),
  table: ({ children }) => (
    <div className="overflow-x-auto border border-gray-200 rounded-md">
      <table className="min-w-full text-sm">{children}</table>
    </div>
  ),
  thead: ({ children }) => <thead className="bg-gray-50">{children}</thead>,
  th: ({ children }) => (
    <th className="px-3 py-2 text-left font-medium text-gray-500 border-b border-gray-200 whitespace-nowrap">
      {children}
    </th>
  ),
  td: ({ children }) => (
    <td className="px-3 py-2 border-b border-gray-100 align-top">{children}</td>
  ),
  pre: ({ children }) => (
    <pre className="bg-white text-gray-900 border border-gray-200 text-xs rounded-md p-4 overflow-x-auto">
      {children}
    </pre>
  ),
  // Block code is styled by its <pre>, and json blocks are coloured; only
  // inline code needs its own chip.
  code: ({ className, children }) =>
    className === "language-json" ? (
      <JsonCode text={String(children)} />
    ) : className ? (
      <code className={className}>{children}</code>
    ) : (
      <code className="bg-gray-100 rounded px-1 py-0.5 text-xs">
        {children}
      </code>
    ),
};

const AxleAiMarkdown = ({ text }: { text: string }) => (
  <div className="flex flex-col gap-y-3 text-sm text-gray-900">
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {text}
    </ReactMarkdown>
  </div>
);

export default AxleAiMarkdown;
